import { Link } from 'react-router-dom';

export default function RegisterPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-secondary-50 p-8">
      <div className="max-w-md w-full text-center">
        <Link to="/" className="flex items-center gap-2 justify-center mb-8">
          <div className="w-10 h-10 bg-primary-600 rounded-lg flex items-center justify-center">
            <span className="text-white font-bold text-xl">C</span>
          </div>
          <span className="font-display font-bold text-xl text-secondary-900">
            Consulting
          </span>
        </Link>

        <h1 className="text-3xl font-display font-bold text-secondary-900">
          Registration Coming Soon
        </h1>
        <p className="mt-4 text-secondary-600">
          Account registration is by invitation only. If you're a client, 
          you should have received an invitation email with login credentials.
        </p>
        <p className="mt-4 text-secondary-600">
          If you haven't received your invitation or need assistance, please 
          contact us.
        </p>

        <div className="mt-8 space-y-4">
          <Link to="/contact" className="btn-primary w-full">
            Contact Us
          </Link>
          <Link to="/login" className="btn-secondary w-full">
            Back to Login
          </Link>
        </div>
      </div>
    </div>
  );
}
